/* eslint-disable no-param-reassign */
import ticketService from "src/services/ticketService";

export const GET_TICKETS_REQUEST = "@ticket/get-tickets-request";
export const GET_TICKETS_SUCCESS = "@ticket/get-tickets-success";
export const GET_TICKETS_FAILURE = "@ticket/get-tickets-failure";

export const UPDATE_TICKET_REQUEST = "@ticket/udpate-ticket-request";
export const UPDATE_TICKET_SUCCESS = "@ticket/udpate-ticket-success";
export const UPDATE_TICKET_FAILURE = "@ticket/udpate-ticket-failure";

export const GET_TICKET_HISTORIES_REQUEST = "@ticket/get-ticket-histories-request";
export const GET_TICKET_HISTORIES_SUCCESS = "@ticket/get-ticket-histories-success";
export const GET_TICKET_HISTORIES_FAILURE = "@ticket/get-ticket-histories-failure";

export function getListTickets(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_TICKETS_REQUEST});
      const response = await ticketService.getListTickets(data);
      dispatch({
        type: GET_TICKETS_SUCCESS,
        payload: {
          response: response.data,
          total: response.total_items || 0
        }
      });
    } catch (error) {
      dispatch({type: GET_TICKETS_FAILURE});
      throw error;
    }
  };
}

export function updateTicket(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_TICKET_REQUEST});
      const response = await ticketService.updateTicket(data);
      dispatch({
        type: UPDATE_TICKET_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_TICKET_FAILURE});
      throw error;
    }
  };
}

export function getListTicketHistories(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_TICKET_HISTORIES_REQUEST});
      const response = await ticketService.getListTicketHistories(data);
      dispatch({
        type: GET_TICKET_HISTORIES_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_TICKET_HISTORIES_FAILURE});
      throw error;
    }
  };
}
